import styled from 'styled-components'

import { ButtonWrapper } from '@/components/Button/Button.styles'

export const ConfirmationWrapper = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ConfirmationContent = styled.div`
  text-align: center;
  margin: auto;
  min-height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 4vh;

  h1 {
    margin-bottom: 0;
  }

  p {
    padding-top: 1rem;
  }

  > button {
    + button {
      margin-top: 1rem;
    }
  }
`

export const CheckoutAddon = styled.div`
  margin-top: 3vh;
  border-top: 2px solid var(--color-line);
  padding-top: 3vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${ButtonWrapper} {
    max-width: 75%;
  }
`

export const ConfirmationIcon = styled.div`
  margin-bottom: 2rem;
`

export const ConfirmationFooter = styled.div`
  margin-top: auto;
`

export const ConfirmationGallery = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  margin-bottom: var(--view-padding-vertical);
  img {
    max-width: 40%;

    &:nth-child(2) {
      margin-top: 10%;
    }
  }
`
